import { Observable } from 'rxjs'

export abstract class LaskuttavaAsiakasProvider {
  public abstract annaLaskuttavaAsiakasAvain(): Promise<string | null>
  public abstract onkoOssRekisterissa(): Observable<boolean>
  public abstract onkoAlvRekisterissa(): Observable<boolean>
}
